export default __webpack_public_path__ + "static/media/QuestionIcon.3ed138f9.svg";